var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2V5H17V2H15ZM20.6124 21.2657C22.0759 19.9827 23 18.0992 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 16.1418 9.00422 16.2826 9.01253 16.4223C8.32778 16.663 7.68849 17.0002 7.11101 17.4176C7.03795 16.9558 7 16.4824 7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16C25 18.4685 24.0062 20.7049 22.3968 22.3309C21.8886 21.8603 21.2825 21.4938 20.6124 21.2657ZM27 15H30V17H27V15ZM27.6243 8.13397L25.0263 9.63397L26.0263 11.366L28.6243 9.86603L27.6243 8.13397ZM20.634 5.97381L22.134 3.37573L23.8661 4.37573L22.3661 6.97381L20.634 5.97381ZM8.13397 4.37573L9.63397 6.97381L11.366 5.97381L9.86603 3.37573L8.13397 4.37573ZM5.97375 11.366L3.37567 9.86603L4.37567 8.13397L6.97375 9.63397L5.97375 11.366ZM5 15H2V17H5V15ZM27.6244 23.866L25.0263 22.366L26.0263 20.634L28.6244 22.134L27.6244 23.866Z",
    fill: "url(#paint0_linear_9_1432)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 27.9998C11.5278 27.9998 11.5556 27.9996 11.5833 27.9992H18.9332C18.946 27.9994 18.9588 27.9996 18.9716 27.9998H19V27.9999C19 27.9999 19 27.9999 19 27.9999C20.6569 27.9999 22 26.6567 22 24.9999C22 23.343 20.6569 21.9999 19 21.9999C18.2306 21.9999 17.5289 22.2895 16.9979 22.7657C17.0021 22.6776 17.0042 22.5891 17.0042 22.5C17.0042 21.8247 16.8825 21.1779 16.6598 20.5802C17.358 20.2097 18.1545 19.9999 19 19.9999C21.7614 19.9999 24 22.2385 24 24.9999C24 27.7613 21.7614 29.9999 19 29.9999C18.9878 29.9999 18.9756 29.9998 18.9634 29.9998L11.5388 29.9998V29.9997C11.5258 29.9997 11.5129 29.9998 11.5 29.9998C7.35787 29.9998 4 26.6419 4 22.4998C4 18.3576 7.35787 14.9998 11.5 14.9998C14.7721 14.9998 17.5548 17.0951 18.5794 20.0173C17.889 20.0748 17.2385 20.2725 16.6564 20.5819C15.878 18.49 13.8631 16.9998 11.5 16.9998C8.46244 16.9998 6 19.4622 6 22.4998C6 25.5373 8.46244 27.9998 11.5 27.9998Z",
    fill: "url(#paint1_linear_9_1432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_1432",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 23.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_1432",
    x1: 14,
    y1: 14.9998,
    x2: 14,
    y2: 29.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD100);
export default __webpack_public_path__ + "static/media/d100.aaebc45bfa203e714c2bff5e761dc91c.svg";
export { ForwardRef as ReactComponent };